/* Slock Master — v11 wishlist ("My Favorites"): nav icon + account link + slide-out drawer + card hearts.
   Ported from version-12 cart.js wishlist. Stores Shopify product handles in localStorage
   (shared key with card hearts); the drawer fetches live product JSON from Shopify (/products/<handle>.js).
   Favorite icon URL is provided by theme.liquid as window.SM_FAV_ICON. */
(function () {
  var WL_KEY = 'slockmaster_wishlist';
  var FAV = window.SM_FAV_ICON || '';
  var _cache = {};
  var _autoTimer = null, _countdown = null;

  function getWL() { try { return JSON.parse(localStorage.getItem(WL_KEY)) || []; } catch (e) { return []; } }
  function saveWL(wl) { localStorage.setItem(WL_KEY, JSON.stringify(wl)); }
  function inWL(id) { return getWL().indexOf(id) >= 0; }
  function money(cents) { try { return (cents / 100).toLocaleString('en-US', { style: 'currency', currency: (window.SM_CURRENCY || 'USD') }); } catch (e) { return '$' + (cents / 100).toFixed(2); } }

  function toggleWL(id) {
    var wl = getWL(), adding = wl.indexOf(id) < 0;
    if (adding) wl.push(id); else wl = wl.filter(function (x) { return x !== id; });
    saveWL(wl); updateHearts(); updateBadge();
    if (adding) openDrawer(true); else renderDrawer();
  }
  function updateBadge() {
    var n = getWL().length;
    document.querySelectorAll('.wl-badge').forEach(function (b) {
      if (n > 0) { b.textContent = n > 99 ? '99+' : n; b.style.display = 'flex'; } else { b.style.display = 'none'; }
    });
  }
  function updateHearts() {
    document.querySelectorAll('.wishlist-btn').forEach(function (btn) {
      if (inWL(btn.dataset.wishlistId)) btn.classList.add('wl-active'); else btn.classList.remove('wl-active');
    });
  }
  function bindHearts() {
    // Clone each heart to strip any inline per-section listeners, then bind the centralized handler
    // (so a card-heart click toggles the wishlist AND opens the drawer — matching version-12).
    document.querySelectorAll('.wishlist-btn').forEach(function (btn) {
      if (btn.dataset.wlBound) return;
      var c = btn.cloneNode(true);
      if (btn.parentNode) btn.parentNode.replaceChild(c, btn);
      c.dataset.wlBound = '1';
      c.addEventListener('click', function (e) { e.preventDefault(); e.stopPropagation(); toggleWL(c.dataset.wishlistId); });
    });
  }

  /* ===== Drawer ===== */
  function injectDrawer() {
    if (document.getElementById('wl-drawer')) return;
    var style = document.createElement('style');
    style.textContent =
      "#wl-drawer{position:fixed;top:0;right:0;bottom:0;width:100%;max-width:24rem;background:#242428;z-index:9999;transform:translateX(100%);transition:transform .3s ease;overflow-y:auto;box-shadow:-4px 0 20px rgba(0,0,0,.3);display:flex;flex-direction:column}" +
      "#wl-drawer.open{transform:translateX(0)}#wl-drawer *{box-sizing:border-box}" +
      "#wl-overlay{position:fixed;inset:0;background:rgba(0,0,0,.5);z-index:9998;opacity:0;pointer-events:none;transition:opacity .3s}#wl-overlay.open{opacity:1;pointer-events:auto}" +
      ".wl-timer-bar{height:3px;background:#FF7E1F;transition:width .1s linear}" +
      ".wl-timer-text{text-align:center;font-family:'Source Sans 3',sans-serif;font-size:.7rem;color:#8a8a90;padding:.35rem 0 0}" +
      ".wl-header{display:flex;align-items:center;justify-content:space-between;padding:1rem 1.25rem;border-bottom:1px solid #3a3a40;flex-shrink:0}" +
      ".wl-header h2{font-family:'Oswald',sans-serif;font-size:1.25rem;text-transform:uppercase;letter-spacing:.1em;color:#d8d9cf;margin:0;display:flex;align-items:center;gap:.5rem}" +
      ".wl-close{background:none;border:none;cursor:pointer;padding:6px;color:#8a8a90;transition:color .2s}.wl-close:hover{color:#d8d9cf}" +
      ".wl-body{flex:1;overflow-y:auto;padding:1rem 1.25rem}.wl-footer{flex-shrink:0;border-top:1px solid #3a3a40;padding:1rem 1.25rem}" +
      ".wl-empty{text-align:center;padding:3rem 1rem}.wl-empty p{font-family:'Source Sans 3',sans-serif;color:#8a8a90;margin-bottom:1.5rem}" +
      ".wl-item{display:flex;gap:.75rem;padding:.75rem 0;border-bottom:1px solid #3a3a40}.wl-item:last-child{border-bottom:none}" +
      ".wl-item-img{width:4rem;height:4rem;border-radius:.5rem;object-fit:cover;background:#3a3a40;flex-shrink:0}" +
      ".wl-item-info{flex:1;min-width:0}" +
      ".wl-item-name{font-family:'Oswald',sans-serif;font-size:.8rem;text-transform:uppercase;letter-spacing:.05em;color:#d8d9cf;margin:0;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;display:block;text-decoration:none}a.wl-item-name:hover{color:#FF7E1F}" +
      ".wl-item-price{font-family:'JetBrains Mono',monospace;font-size:.8rem;color:#FF7E1F;margin:.15rem 0}" +
      ".wl-item-actions{display:flex;flex-direction:column;align-items:flex-end;justify-content:space-between;flex-shrink:0;gap:.35rem}" +
      ".wl-add-cart{padding:.35rem .65rem;background:#FF7E1F;color:#fff;font-family:'Oswald',sans-serif;text-transform:uppercase;letter-spacing:.08em;font-size:.65rem;border:none;border-radius:.375rem;cursor:pointer;transition:background .2s;white-space:nowrap}.wl-add-cart:hover{background:#e06a10}" +
      ".wl-remove{background:none;border:none;cursor:pointer;color:#8a8a90;font-family:'Source Sans 3',sans-serif;font-size:.7rem;transition:color .2s;padding:0}.wl-remove:hover{color:#ef4444}" +
      ".wl-continue{display:block;width:100%;padding:.6rem;background:none;color:#8a8a90;font-family:'Oswald',sans-serif;text-transform:uppercase;letter-spacing:.1em;font-size:.8rem;border:1px solid #3a3a40;border-radius:.5rem;cursor:pointer;transition:all .2s;text-align:center;text-decoration:none}.wl-continue:hover{border-color:#FF7E1F;color:#FF7E1F}" +
      ".wishlist-btn.wl-active{background:rgba(255,126,31,0.9)!important;border-color:#FF7E1F!important}" +
      ".wl-badge{position:absolute;top:-2px;right:-2px;min-width:16px;height:16px;padding:0 3px;background:#FF7E1F;color:#fff;font-size:10px;font-weight:700;border-radius:9999px;display:none;align-items:center;justify-content:center;line-height:1}";
    document.head.appendChild(style);

    var ov = document.createElement('div'); ov.id = 'wl-overlay'; ov.addEventListener('click', closeDrawer); document.body.appendChild(ov);
    var d = document.createElement('div'); d.id = 'wl-drawer';
    d.innerHTML =
      '<div class="wl-header"><h2><img src="' + FAV + '" alt="" width="20" height="20" style="filter:brightness(0) invert(0.5) sepia(1) saturate(10) hue-rotate(0deg) brightness(1.1);"> My Favorites</h2>' +
      '<button class="wl-close" aria-label="Close favorites"><svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M18 6 6 18"/><path d="m6 6 12 12"/></svg></button></div>' +
      '<div class="wl-body" id="wl-body"></div><div class="wl-footer" id="wl-footer"></div>' +
      '<div class="wl-timer-bar" id="wl-timer-bar" style="width:0"></div><div class="wl-timer-text" id="wl-timer-text"></div>';
    document.body.appendChild(d);
    d.querySelector('.wl-close').addEventListener('click', closeDrawer);
  }

  function fetchProduct(handle) {
    if (_cache[handle]) return Promise.resolve(_cache[handle]);
    return fetch('/products/' + handle + '.js').then(function (r) { return r.ok ? r.json() : null; })
      .then(function (p) { _cache[handle] = p; return p; }).catch(function () { return null; });
  }

  function renderDrawer() {
    var body = document.getElementById('wl-body'), footer = document.getElementById('wl-footer');
    if (!body || !footer) return;
    var wl = getWL();
    if (!wl.length) {
      body.innerHTML = '<div class="wl-empty"><img src="' + FAV + '" alt="" width="48" height="48" style="filter:brightness(0) invert(0.55);margin:0 auto 1rem;display:block;"><p>Your favorites list is empty.<br>Tap the heart on products you love!</p><a href="/collections/all" class="wl-continue" style="width:auto;display:inline-block;padding:.6rem 1.5rem">Browse Products</a></div>';
      footer.innerHTML = ''; return;
    }
    body.innerHTML = '<p style="color:#8a8a90;font-family:\'Source Sans 3\',sans-serif;text-align:center;padding:1.5rem .5rem">Loading your favorites…</p>';
    Promise.all(wl.map(fetchProduct)).then(function (prods) {
      var html = '';
      prods.forEach(function (p) {
        if (!p) return;
        var v = p.variants && p.variants[0];
        var img = p.featured_image || (p.images && p.images[0]) || '';
        html += '<div class="wl-item">' +
          '<a href="' + p.url + '" class="wl-item-link"><img src="' + img + '" alt="" class="wl-item-img"></a>' +
          '<div class="wl-item-info"><a href="' + p.url + '" class="wl-item-name">' + p.title + '</a><p class="wl-item-price">' + money(p.price) + '</p></div>' +
          '<div class="wl-item-actions">' +
          '<button class="wl-add-cart" data-vid="' + (v ? v.id : '') + '"' + (v && v.available === false ? ' disabled' : '') + '>Add to Cart</button>' +
          '<button class="wl-remove" data-h="' + p.handle + '">Remove</button>' +
          '</div></div>';
      });
      body.innerHTML = html || '<p style="color:#8a8a90;text-align:center;padding:1.5rem">These items are no longer available.</p>';
      footer.innerHTML = '<button class="wl-continue" id="wl-cont">Continue Shopping</button>';
      var cont = document.getElementById('wl-cont'); if (cont) cont.addEventListener('click', closeDrawer);
      body.querySelectorAll('.wl-add-cart').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var vid = btn.dataset.vid; if (!vid) return; btn.textContent = '…';
          fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ id: vid, quantity: 1 }) })
            .then(function () { window.location.href = '/cart'; });
        });
      });
      body.querySelectorAll('.wl-remove').forEach(function (btn) {
        btn.addEventListener('click', function () { toggleWL(btn.dataset.h); });
      });
    });
  }

  function _clearTimers() { if (_autoTimer) { clearTimeout(_autoTimer); _autoTimer = null; } if (_countdown) { clearInterval(_countdown); _countdown = null; } }
  function _startTimer(seconds) {
    var remaining = seconds, bar = document.getElementById('wl-timer-bar'), txt = document.getElementById('wl-timer-text');
    if (bar) bar.style.width = '100%'; if (txt) txt.textContent = 'Auto-close in ' + remaining + 's';
    _countdown = setInterval(function () {
      remaining--; if (bar) bar.style.width = Math.max(0, (remaining / seconds) * 100) + '%';
      if (txt) txt.textContent = remaining > 0 ? 'Auto-close in ' + remaining + 's' : '';
      if (remaining <= 0) { _clearTimers(); closeDrawer(); }
    }, 1000);
  }
  function openDrawer(autoClose) {
    injectDrawer(); renderDrawer(); _clearTimers();
    var d = document.getElementById('wl-drawer'), o = document.getElementById('wl-overlay');
    requestAnimationFrame(function () { d.classList.add('open'); if (o) o.classList.add('open'); });
    if (autoClose) { _startTimer(5); }
    else { var bar = document.getElementById('wl-timer-bar'), txt = document.getElementById('wl-timer-text'); if (bar) bar.style.width = '0'; if (txt) txt.textContent = ''; }
  }
  function closeDrawer() {
    var d = document.getElementById('wl-drawer'), o = document.getElementById('wl-overlay');
    if (d) d.classList.remove('open'); if (o) o.classList.remove('open'); _clearTimers();
  }
  window.wlOpenDrawer = openDrawer; window.wlCloseDrawer = closeDrawer;

  /* ===== Nav injection ===== */
  function injectNav() {
    // Desktop: favorites icon before the cart icon
    var cart = document.getElementById('cart-icon');
    if (cart && !document.getElementById('wl-icon-desktop')) {
      var a = document.createElement('a');
      a.id = 'wl-icon-desktop'; a.href = '#'; a.title = 'My Favorites';
      a.className = 'relative p-2 nav-text hover:text-sienna transition-colors flex';
      a.innerHTML = '<img src="' + FAV + '" alt="Favorites" width="26" height="26" style="filter:brightness(0) invert(1);"><span class="wl-badge" style="display:none;"></span>';
      a.addEventListener('click', function (e) { e.preventDefault(); openDrawer(); });
      cart.parentNode.insertBefore(a, cart);
    }
    // Mega-menu Account: "My Favorites" link
    var acct = document.querySelector('[data-menu-cat="account"] .flex.flex-col.gap-5');
    if (acct && !document.getElementById('wl-menu-link')) {
      var m = document.createElement('a');
      m.id = 'wl-menu-link'; m.href = '#';
      m.className = 'flex items-center gap-3 text-parchment/70 hover:text-sienna transition-colors';
      m.innerHTML = '<img src="' + FAV + '" alt="" class="w-5 h-5 shrink-0" style="filter:brightness(0) invert(0.55);"><span class="font-display text-sm uppercase tracking-wider">My Favorites</span>';
      m.addEventListener('click', function (e) { e.preventDefault(); if (typeof closeMegaMenu === 'function') closeMegaMenu(); openDrawer(); });
      acct.appendChild(m);
    }
  }

  function init() { injectNav(); bindHearts(); updateHearts(); updateBadge(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
